import { api } from "api/api"
import { AxiosError } from "axios";
import IndicadorDashboard from "components/chart/IndicadorDashboard"
import { ChartBarModel } from "model/chart/ChartBarModel";
import { ChartLineModel } from "model/chart/ChartLineModel"
import { ChartPieModel } from "model/chart/ChartPieModel";
import ItemDashboard from "model/dashboard/ItemDashboard";
import ManutencaoDashboardTable from "model/gestao/frotas/ManutencaoDashboardTable"

export default class DashboardService {

    itensDashboard() {
        return new Promise<Array<ItemDashboard>>((resolve, reject): void => {
            let url = `/dashboard/itensDashboard`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarGraficoPizza(itemDashboard: string) {
        return new Promise<ChartPieModel>((resolve, reject): void => {
            api.get(`/dashboard/graficoPizza/${itemDashboard}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response))
        })
    }

    buscarGraficoLinha(itemDashboard: string) {
        return new Promise<ChartLineModel>((resolve, reject): void => {
            api.get(`/dashboard/graficoLinha/${itemDashboard}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response))
        })
    }

    buscarGraficoBarra(itemDashboard: string) {
        return new Promise<ChartBarModel>((resolve, reject): void => {
            api.get(`/dashboard/graficoBarra/${itemDashboard}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response))
        })
    }

    buscarIndicador(itemDashboard: string) {
        return new Promise<IndicadorDashboard>((resolve, reject) => {
            api.get(`/dashboard/indicador/${itemDashboard}`)
                .then(response => resolve(response.data))
                .catch((err) => reject(err.response))
        })
    }
    
    getIndicador(indicador: IndicadorDashboard, codigoItem: string) {
        const indicadores = [
            { codigoItem: "INDICADOR_AUDITORIA_MAIOR_QUANTIDADE_REALIZADA_MES", imagem: "/imagens/indicador-lupa.png", valorTexto: indicador.valor + " auditorias" },
            { codigoItem: "INDICADOR_FROTAS_MAIOR_GASTO_ANO", imagem: "/imagens/indicador-dinheiro.png", valorTexto: "R$" + indicador.valor.toFixed(2).replace(".", ",") },
            { codigoItem: "INDICADOR_FROTAS_MAIOR_GASTO_VEICULO", imagem: "/imagens/indicador-dinheiro.png", valorTexto: "R$" + indicador.valor.toFixed(2).replace(".", ",") },
            { codigoItem: "INDICADOR_FROTAS_MAIS_MANUTENCOES_ANO", imagem: "/imagens/indicador-manutencao.png", valorTexto: indicador.valor + " manutenções" },
            { codigoItem: "INDICADOR_FROTAS_MAIS_MANUTENCOES_VEICULO", imagem: "/imagens/indicador-manutencao.png", valorTexto: indicador.valor + " manutenções" },
            { codigoItem: "INDICADOR_PRODUCAO_METAS_PRODUCOES_NO_MES", imagem: "/imagens/indicador-engrenagem.png", valorTexto: indicador.valor + " peças" },
            { codigoItem: "INDICADOR_PRODUCAO_MAIOR_QUANTIDADE_APONTADA", imagem: "/imagens/indicador-engrenagem.png", valorTexto: indicador.valor + " peças" },
            { codigoItem: "INDICADOR_PRODUCAO_MAIOR_QUANTIDADE_APONTADA_NO_MES", imagem: "/imagens/indicador-engrenagem.png", valorTexto: indicador.valor + " peças" },
            { codigoItem: "INDICADOR_PRODUCAO_DEFEITOS_NO_MES", imagem: "/imagens/indicador-dislike.png", valorTexto: indicador.valor + " defeitos" },
            { codigoItem: "INDICADOR_PRODUCAO_MAIOR_OCORRENCIA_DEFEITO_NO_MES", imagem: "/imagens/indicador-dislike.png", valorTexto: indicador.valor + " defeitos" },
            { codigoItem: "INDICADOR_PRODUCAO_MAIOR_OCORRENCIA_DEFEITO_NO_DIA", imagem: "/imagens/indicador-dislike.png", valorTexto: indicador.valor + " defeitos" },
            { codigoItem: "INDICADOR_HELPDESK_CHAMADOS_STATUS_AGUARDANDO_ATENDENTE", imagem: "/imagens/indicador-dislike.png", valorTexto: indicador.valor + " chamados" },
            { codigoItem: "INDICADOR_VIAGENS_DESPESAS_NO_MES", imagem: "/imagens/indicador-dinheiro.png", valorTexto: "R$ " + indicador.valor.toFixed(2).replace(".", ",") },
        ]

        return indicadores.find((indicadorItem) => indicadorItem.codigoItem === codigoItem) || { imagem: "", valorTexto: "" }
    }

    getGraficoBarra(grafico: ChartBarModel, codigoItem: string) : { tickValues: number[] | undefined, colorFunction: ((datum: any) => string) | undefined, textFunction: ((valor: number) => string) | undefined } {
        const graficos = [
            { codigoItem: "GRAFICO_AUDITORIA_MES", tickValues: undefined, colorFunction: (datum: any) => "#0364FF", textFunction: undefined },
            { codigoItem: "GRAFICO_AUDITORIA_FINALIZADAS_MES", tickValues: undefined, colorFunction: (datum: any) => "#0364FF", textFunction: undefined },
            { codigoItem: "GRAFICO_AUDITORIA_ITENS_NAO_CONFORMES_MES", tickValues: undefined, colorFunction: (datum: any) => "#FF0000", textFunction: undefined },
            { codigoItem: "GRAFICO_SUPRIMENTOS_GASTO_POR_MES", tickValues: undefined, colorFunction: undefined, textFunction: undefined },
            {
                codigoItem: "GRAFICO_AUDITORIA_EVOLUCAO_SETOR", tickValues: [0, 2, 4, 6, 8, 10], colorFunction: (datum: any) => {
                    if (datum.datum && datum.datum.y) {
                        if (datum.datum.y >= 8) {
                            return "#00611F";
                        } else if (datum.datum.y >= 6) {
                            return "#FFBE0D";
                        }
                        return "red";
                    }
                    return "red";
                },
                textFunction: undefined
            },
            { codigoItem: "GRAFICO_PRODUCAO_DEFEITOS_POR_MES", tickValues: undefined, colorFunction: (datum: any) => "#DC2727", textFunction: undefined },
            { codigoItem: "GRAFICO_PRODUCAO_METAS_PRODUCOES_POR_MES", tickValues: undefined, colorFunction: (datum: any) => "#00611F", textFunction: undefined },
            { codigoItem: "GRAFICO_VIAGENS_DESPESAS_POR_MES", tickValues: undefined, colorFunction: undefined, textFunction: (valor: number)=>"R$"+valor.toFixed(2).replace(".", ",") },
            { codigoItem: "GRAFICO_VIAGENS_DESPESAS_POR_USUARIO_MES", tickValues: undefined, colorFunction: undefined, textFunction: (valor: number)=>"R$"+valor.toFixed(2).replace(".", ",") },
        ]


        return graficos.find((indicadorItem) => indicadorItem.codigoItem === codigoItem) || { tickValues: undefined, colorFunction: undefined, textFunction: undefined }
    }

    getTiposItem() {
        return [
            { label: "Gráfico de Linha", value: "GRAFICO_LINHA" },
            { label: "Gráfico de Barra", value: "GRAFICO_BARRA" },
            { label: "Gráfico de Pizza", value: "GRAFICO_PIZZA" },
            { label: "Gráfico de Barra Horizontal", value: "GRAFICO_BARRA_HORIZONTAL" },
            { label: "Indicador", value: "INDICADOR" }
        ]
    }

    getTipoItem(tipo: string) {
        return this.getTiposItem().find((tipoItem) => tipoItem.value === tipo)?.label || ""
    }

}
